const PROJECT_OPEN_HISTORY_PREFIX = 'latted:project-open-history:v1:';
const MAX_OPEN_PROJECTS = 500;

function storageKey(userId) {
  return `${PROJECT_OPEN_HISTORY_PREFIX}${String(userId || '')}`;
}

function readProjectOpenHistory(userId) {
  if (!userId || typeof window === 'undefined') return {};
  try {
    const parsed = JSON.parse(window.localStorage.getItem(storageKey(userId)) || '{}');
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

export function markProjectOpened(userId, projectId, openedAt = Date.now()) {
  if (!userId || !projectId || typeof window === 'undefined') return;
  try {
    const history = readProjectOpenHistory(userId);
    history[String(projectId)] = Number(openedAt) || Date.now();
    const bounded = Object.fromEntries(
      Object.entries(history)
        .sort(([, left], [, right]) => Number(right) - Number(left))
        .slice(0, MAX_OPEN_PROJECTS)
    );
    window.localStorage.setItem(storageKey(userId), JSON.stringify(bounded));
  } catch {
    // Opening the editor must not depend on browser storage being available.
  }
}

export function wasProjectOpenedAfter(userId, projectId, completedAt) {
  const openedAt = Number(readProjectOpenHistory(userId)[String(projectId)] || 0);
  const completedAtMs = new Date(completedAt || 0).getTime();
  return openedAt > 0 && (!Number.isFinite(completedAtMs) || openedAt >= completedAtMs);
}

